<script>
  import Pagination from '@/components/pagination/index.vue';
  import BaseListLayout from '@/views/layout/components/BaseListLayout.vue';
  import { myMixin } from '@/mixins/mixins.js';
  import { handleSortItem } from 'utils/utils';
  import { formatDate } from 'utils/dateutils';
  import BillingOperationBaseForm from '@/views/billing/forms/AffHedgeAppBaseForm.vue';
  import { getAffHedgeAppList } from 'api/affSendingBilling/application/affHedgeApplication';
  import { billingEnumMixins } from '@/mixins/billingEnumMixins';
  import { financeInfoMixins } from '@/mixins/financeInfoMixins';

  const defaultAdvertiserForm = {
    id: null,
    recordStartDate: null,
    recordEndDate: null,
    companyPlatform: null,
    companyEntity: null,
    billingEntity: null,
    hedgeAmount: null,
    receivedAmount: null,
    paymentAmount: null,
    remark: null,
  };

  export default {
    name: 'AffDeductionApp',
    components: {
      BillingOperationBaseForm,
      BaseListLayout,
      Pagination,
    },
    mixins: [myMixin, billingEnumMixins, financeInfoMixins],
    data() {
      return {
        dialogVisible: false,
        dialogType: 'new',
        editData: Object.assign({}, defaultAdvertiserForm),
        total: 0,
        listLoading: false,
        dataList: [],
        auditStatus: null,
        filter: {
          page: 1,
          pageSize: 10,
          affCompanyPlatform: null,
          affEntity: null,
          hyperTapEntity: null,
          auditStatus: null,
          paymentStatus: null,
          affHedgeAppNumber: null,
          recordDateRange: [formatDate(new Date(), 'yyyy-MM'), formatDate(new Date(), 'yyyy-MM')],
          sortItems: [],
        },
      };
    },
    mounted() {
      this.handleSearch();
    },
    methods: {
      handleSizeChange(size) {
        this.filter.pageSize = size;
        this.handleSearch(1);
      },
      handleCurrentChange(currentPage) {
        this.filter.page = currentPage;
        this.handleSearch(currentPage);
      },

      handleSort(columnInfo) {
        const sortItem = handleSortItem(columnInfo);
        if (sortItem === '') {
          return;
        }
        this.filter.sortItems = [];
        this.filter.sortItems.push(sortItem);
        this.handleSearch(1);
      },
      handleCreate() {
        this.dialogType = 'new';
        this.dialogVisible = true;
        this.editData = {
          companyPlatform: null,
          companyEntity: null,
          receivedAmount: null,
          paymentAmount: null,
          recordStartDate: formatDate(new Date(), 'yyyy-MM'),
          recordEndDate: formatDate(new Date(), 'yyyy-MM'),
        };
      },
      handleSearch(page) {
        this.listLoading = true;
        if (page) {
          this.filter.page = page;
        }
        getAffHedgeAppList(this.filter)
          .then((res) => {
            if (res) {
              const result = res.result;
              this.dataList = result.dataList;
              this.total = res.total;
            }
          })
          .catch(() => {})
          .finally(() => {
            this.listLoading = false;
          });
      },
      handleApprovalForm(dialogType, auditStatus) {
        this.dialogType = dialogType;
        this.auditStatus = auditStatus;
        this.dialogVisible = true;
        this.editData = {};
      },
    },
  };
</script>

<template>
  <base-list-layout :title="'Aff Hedge Management'">
    <template #search>
      <el-form :inline="true" :model="filter" label-width="180px" ref="searchForm">
        <el-form-item label="Date">
          <el-date-picker
            v-model="filter.recordDateRange"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="monthrange"
            clearable
            style="width:260px;"
            align="right"
            unlink-panels
            range-separator="to"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="monthPickerOptions"
          />
        </el-form-item>
        <el-form-item label="Application Number">
          <el-input v-model="filter.affHedgeAppNumber" />
        </el-form-item>
        <el-form-item label="Aff Company Platform">
          <el-select
            v-model="filter.affCompanyPlatform"
            filterable
            clearable
            @change="handleCompanyPlatformChange(filter.affCompanyPlatform)"
          >
            <el-option
              v-for="item in companyPlatformList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Aff Entity">
          <el-select v-model="filter.affEntity" ref="companyEntityOptions" filterable clearable>
            <el-option
              v-for="item in specificCompanyEntity"
              :key="item.id"
              :label="item.companyEntity"
              :value="item.companyEntity"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="HyperTap Entity">
          <div class="row-multi-item">
            <el-select
              v-model="filter.hyperTapEntity"
              filterable
              clearable
              placeholder="please select"
            >
              <el-option
                v-for="item in hyperTapCompanyEntities"
                :key="item.bfiId"
                :label="item.companyEntityAlias"
                :value="item.companyEntity"
              />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="Payment Status">
          <el-select
            v-model="filter.paymentStatus"
            filterable
            clearable
            placeholder="please select"
          >
            <el-option
              v-for="item in affHedgeAppPaymentStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Application Status">
          <el-select v-model="filter.auditStatus" filterable clearable placeholder="please select">
            <el-option
              v-for="item in affHedgeAppAuditStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </template>
    <template #search-actions>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch(1)">Search</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="handleCreate">Create</el-button>
      <el-button type="success" @click="handleApprovalForm('status', 'APPROVED')"
        >Approve</el-button
      >
      <el-button type="warning" @click="handleApprovalForm('status', 'REJECTED')"
        >UnApprove</el-button
      >
      <el-button type="primary" @click="handleApprovalForm('status', 'AUTO_PAYMENT')"
        >Auto Payment</el-button
      >
    </template>
    <template #table>
      <el-table
        v-loading="listLoading"
        ref="tableRef"
        stripe
        border
        :data="dataList"
        highlight-current-row
        @sort-change="handleSort"
      >
        <el-table-column
          label="Aff Hedge Application Number"
          prop="affHedgeAppNumber"
          fixed="left"
          align="center"
          width="230"
          key="affHedgeAppNumber"
        />
        <el-table-column
          label="Date"
          prop="recordDate"
          fixed="left"
          align="center"
          width="120"
          key="recordStartDate"
        />

        <el-table-column
          label="Company Platform"
          prop="affCompanyPlatform"
          align="center"
          width="170"
          key="companyPlatform"
        />
        <el-table-column
          label="Aff Entity"
          prop="affEntity"
          align="center"
          width="170"
          key="affEntity"
        />

        <el-table-column
          label="HyperTap Entity"
          prop="hyperTapEntity"
          align="center"
          key="hyperTapEntity"
          width="160"
        >
          <template #default="scope">
            {{ getHyperTapCompanyAlias(scope.row.hyperTapEntity) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Aff Revenue"
          prop="affRevenue"
          align="center"
          key="affRevenue"
          width="140"
          sortable="custom"
        />
        <el-table-column
          label="Aff Confirmed Amount"
          prop="affConfirmedAmount"
          align="center"
          key="affConfirmedAmount"
          width="200"
          sortable="custom"
        />
        <el-table-column
          label="Hedge Amount"
          prop="affHedgeAmount"
          align="center"
          key="affHedgeAmount"
          width="160"
          sortable="custom"
        />

        <el-table-column
          label="Aff Hedge Application Status"
          prop="auditStatus"
          align="center"
          key="auditStatus"
          width="240"
          fixed="right"
        >
          <template #default="scope">
            {{ getApplicationAuditStatus(scope.row.auditStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Payment Status"
          prop="paymentStatus"
          align="center"
          key="paymentStatus"
          width="140"
        >
          <template #default="scope">
            {{ getPaymentStatus(scope.row.paymentStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Remark"
          prop="remark"
          :show-overflow-tooltip="true"
          align="center"
          key="remark"
          width="250"
        />
        <el-table-column
          label="Audit Remark"
          prop="auditRemark"
          :show-overflow-tooltip="true"
          align="center"
          key="auditRemark"
          width="250"
        />
        <el-table-column
          label="Create Time"
          prop="createTime"
          align="center"
          key="createTime"
          width="160"
        />
        <el-table-column
          label="Create By"
          prop="createBy"
          align="center"
          key="createBy"
          width="160"
        />
      </el-table>
    </template>
    <template #pagination>
      <pagination
        class="block pagePanel"
        :pageTotal="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="filter.pageSize"
        :currentPage="filter.page"
      />
    </template>
    <template #dialog>
      <billing-operation-base-form
        :dialogVisible.sync="dialogVisible"
        :dialog-type="dialogType"
        :auditStatus.sync="auditStatus"
        :editData="editData"
        @refresh-list="handleSearch"
      />
    </template>
  </base-list-layout>
</template>

<style scoped lang="scss"></style>
